const _debounce = require('lodash.debounce');

window.addEventListener('load', () => {
    const heroPanels = document.querySelectorAll('.header-panel');

    for (const hero of heroPanels) {
        const heroMediaContainers = hero.querySelectorAll('[data-hero-media-container]');
        if (!heroMediaContainers.length) continue;

        const updateHeroVideoPosition = () => {
            const rect = hero.getBoundingClientRect();
            // Stop updating once the hero is fully above the viewport
            if (rect.bottom <= 0) {
                for (const heroMediaContainer of heroMediaContainers) {
                    heroMediaContainer.style.transform = '';
                }
                return;
            }
            const offset = rect.top;
            const translateY = `translateY(${-offset * 0.2}px)`;
            for (const heroMediaContainer of heroMediaContainers) {
                heroMediaContainer.style.transform = translateY;
            }
        };

        const debouncedResizeHandler = _debounce(updateHeroVideoPosition, 150);

        window.addEventListener('scroll', updateHeroVideoPosition);
        window.addEventListener('resize', debouncedResizeHandler);

        // Run on initial load
        updateHeroVideoPosition();
    }
});
